// src/components/product/product-shopping-criteria-provider.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  query PropertySearchQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: false\n    ) {\n      searchCriteria {\n        searchId\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query FlightSearchQuery(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $searchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $searchPreferences: FlightsSearchPreferencesInput\n    $sortOption: FlightsSortOptionTypeInput\n    $travelerDetails: [FlightsTravelerDetailsInput!]\n  ) {\n    flightsSearch(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      searchPreferences: $searchPreferences\n      searchFilterValuesList: $searchFilterValuesList\n      travelerDetails: $travelerDetails\n      sortOption: $sortOption\n    ) {\n      gaiaId\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React13 from "react";
import { gql } from "@apollo/client";
import { ProductType, useProductType } from "@shared-ui/retail-product-type-providers";
// src/components/cars/cars-criteria-provider.tsx
import React3 from "react";
// src/components/cars/cars-criteria-context.ts
import React from "react";
var CarsCriteriaContext = React.createContext(null);
var CarsCriteriaDispatchContext = React.createContext(null);
// src/components/cars/cars-criteria-reducer.ts
import React2 from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useLocalization } from "@shared-ui/localization-context";
// src/components/product/product-shopping-criteria-action.tsx
var ProductShoppingCriteriaInputActionType = /* @__PURE__ */function (ProductShoppingCriteriaInputActionType2) {
  ProductShoppingCriteriaInputActionType2[ProductShoppingCriteriaInputActionType2["READ_PARAMS_FROM_URL"] = 0] = "READ_PARAMS_FROM_URL";
  ProductShoppingCriteriaInputActionType2[ProductShoppingCriteriaInputActionType2["MULTI_SELECT_CLEAR_ALL"] = 1] = "MULTI_SELECT_CLEAR_ALL";
  ProductShoppingCriteriaInputActionType2[ProductShoppingCriteriaInputActionType2["MULTI_SELECT_CLOSE"] = 2] = "MULTI_SELECT_CLOSE";
  ProductShoppingCriteriaInputActionType2[ProductShoppingCriteriaInputActionType2["FILTER_UPDATE"] = 3] = "FILTER_UPDATE";
  ProductShoppingCriteriaInputActionType2[ProductShoppingCriteriaInputActionType2["SEARCH_FORM_UPDATE"] = 4] = "SEARCH_FORM_UPDATE";
  return ProductShoppingCriteriaInputActionType2;
}(ProductShoppingCriteriaInputActionType || {});
// src/utils/date-utils.ts
var DATE_FORMATS_BY_LOCALE = [{
  locale: "en_AU" /* EN_AU */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_CA" /* EN_CA */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_GB" /* EN_GB */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_IE" /* EN_IE */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_MY" /* EN_MY */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_SG" /* EN_SG */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_US" /* EN_US */,
  format: "MM-dd-YYYY" /* MONTH_DAY_YEAR */,
  siteid: 1
}, {
  locale: "en_US" /* EN_US */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 12
}, {
  locale: "en_US" /* EN_US */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */,
  siteid: 16
}, {
  locale: "en_US" /* EN_US */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */,
  siteid: 28
}, {
  locale: "en_US" /* EN_US */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */,
  siteid: 62
}, {
  locale: "en_US" /* EN_US */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 69
}, {
  locale: "es_AR" /* ES_AR */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "es_ES" /* ES_ES */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "es_MX" /* ES_MX */,
  format: "MM-dd-YYYY" /* MONTH_DAY_YEAR */,
  siteid: 1
}, {
  locale: "es_MX" /* ES_MX */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 12
}, {
  locale: "es_MX" /* ES_MX */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 4403
}, {
  locale: "es_MX" /* ES_MX */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 4404
}, {
  locale: "es_MX" /* ES_MX */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 4405
}, {
  locale: "es_MX" /* ES_MX */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */,
  siteid: 4407
}, {
  locale: "da_DK" /* DA_DK */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "de_AT" /* DE_AT */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "de_DE" /* DE_DE */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "de_CH" /* DE_CH */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "fi_FI" /* FI_FI */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "fr_CH" /* FR_CH */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "fr_BE" /* FR_BE */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "fr_CA" /* FR_CA */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "fr_FR" /* FR_FR */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "nl_BE" /* NL_BE */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "nl_NL" /* NL_NL */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "nb_NO" /* NB_NO */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "pt_BR" /* PT_BR */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "zh_HK" /* ZH_HK */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "vi_VN" /* VI_VN */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "it_IT" /* IT_IT */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "ms_MY" /* MS_MY */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "id_ID" /* ID_ID */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "th_TH" /* TH_TH */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "ca_ES" /* CA_ES */,
  format: "dd-MM-YYYY" /* DAY_MONTH_YEAR */
}, {
  locale: "en_PH" /* EN_PH */,
  format: "MM-dd-YYYY" /* MONTH_DAY_YEAR */
}, {
  locale: "en_HK" /* EN_HK */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}, {
  locale: "ja_JP" /* JA_JP */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}, {
  locale: "ko_KR" /* KO_KR */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}, {
  locale: "sv_SE" /* SV_SE */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}, {
  locale: "zh_CN" /* ZH_CN */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}, {
  locale: "zh_TW" /* ZH_TW */,
  format: "YYYY-MM-dd" /* YEAR_MONTH_DAY */
}];
var createDateStringWithFormat = function (dateParts, format) {
  if (format === "dd-MM-YYYY" /* DAY_MONTH_YEAR */) {
    return {
      day: dateParts[0],
      month: dateParts[1],
      year: dateParts[2]
    };
  }
  if (format === "MM-dd-YYYY" /* MONTH_DAY_YEAR */) {
    return {
      day: dateParts[1],
      month: dateParts[0],
      year: dateParts[2]
    };
  }
  return {
    day: dateParts[2],
    month: dateParts[1],
    year: dateParts[0]
  };
};
var dateToDateInput = function (date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
};
var getTimeTuple = function (timeStrParam, defaultTime) {
  var timeStr = timeStrParam !== null && timeStrParam !== void 0 ? timeStrParam : defaultTime;
  var _timeStr_split_map = _sliced_to_array(timeStr.split(":").map(function (val) {
      return parseInt(val, 10);
    }), 2),
    hour = _timeStr_split_map[0],
    minute = _timeStr_split_map[1];
  return [!Number.isNaN(hour) ? hour : 10, minute !== void 0 && !Number.isNaN(minute) ? minute : 30];
};
var isoDateToDateInput = function (dateString) {
  var _dateString_split_map = _sliced_to_array(dateString.split("-").map(function (datePart) {
      return Number.parseInt(datePart, 10);
    }), 3),
    year = _dateString_split_map[0],
    month = _dateString_split_map[1],
    day = _dateString_split_map[2];
  return {
    day: day,
    month: month,
    year: year
  };
};
var formatDateStringToIsoDate = function (dateString, l10n, localDateFormat) {
  var localDate;
  try {
    localDate = l10n.parseLocalDateString(dateString, localDateFormat ? {
      raw: localDateFormat
    } : {});
  } catch (localDateFormatParseError) {
    try {
      localDate = l10n.parseLocalDateString(dateString, {
        raw: "yyyy-MM-dd"
      });
    } catch (isoDateFormatParseError) {
      return null;
    }
  }
  var cleanDate = l10n.formatDate(localDate, {
    raw: "yyyy-MM-dd"
  });
  return cleanDate || null;
};
var formatDateString = function (completeDateString, locale, siteId) {
  var brokenDownDateString = completeDateString.replace("TANYT", "").split(/[/.-]/).map(function (i) {
    return parseInt(i, 10);
  });
  var localeDateFormat = "MM-dd-YYYY" /* MONTH_DAY_YEAR */;
  var dateFormats = DATE_FORMATS_BY_LOCALE.filter(function (dateFormat) {
    return dateFormat.locale === locale;
  });
  if (dateFormats.length > 1) {
    var siteIdFormats = dateFormats.filter(function (format) {
      return format.siteid === siteId;
    });
    if (siteIdFormats.length > 0) {
      localeDateFormat = siteIdFormats[0].format;
    }
  } else if (dateFormats.length === 1) {
    localeDateFormat = dateFormats[0].format;
  }
  return createDateStringWithFormat(brokenDownDateString, localeDateFormat);
};
var convertTo24HourFormat = function (legacyTimeStr) {
  var hours;
  var minutes;
  var phase;
  var rawString = legacyTimeStr;
  if (rawString.length === 3 || rawString.length === 5) {
    rawString = "0".concat(rawString);
  }
  switch (rawString.length) {
    case 4:
      hours = parseInt(rawString.substring(0, 2), 10);
      minutes = parseInt(rawString.substring(2, 4), 10);
      break;
    case 6:
      hours = parseInt(rawString.substring(0, 2), 10);
      minutes = parseInt(rawString.substring(2, 4), 10);
      phase = rawString.substring(4, 6).toUpperCase();
      if (phase !== "AM" && phase !== "PM") {
        throw new Error("Failed to parse time value: ".concat(legacyTimeStr));
      }
      break;
    default:
      throw new Error("Failed to parse time value: ".concat(legacyTimeStr));
  }
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    throw new Error("Failed to parse time value: ".concat(legacyTimeStr));
  }
  if (hours === 12 && phase === "AM") {
    hours = 0;
  }
  if (hours !== 12 && phase === "PM") {
    hours += 12;
  }
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    throw new Error("Failed to parse time value: ".concat(legacyTimeStr));
  }
  return "".concat(hours, ":").concat(minutes);
};
var getDateTimeInput = function (dateStr, timeStr, l10n, defaultDate, defaultTime, localeDateFormat) {
  var isoDate = formatDateStringToIsoDate(dateStr !== null && dateStr !== void 0 ? dateStr : defaultDate, l10n, dateStr ? localeDateFormat : "");
  var dateObj = isoDateToDateInput(isoDate !== null && isoDate !== void 0 ? isoDate : defaultDate);
  var _getTimeTuple = _sliced_to_array(getTimeTuple(timeStr, defaultTime), 2),
    hour = _getTimeTuple[0],
    minute = _getTimeTuple[1];
  return _object_spread_props(_object_spread({}, dateObj), {
    hour: hour,
    minute: minute,
    second: 0
  });
};
var dateInputToString = function (dateInput, l10n) {
  if (!dateInput) {
    return null;
  }
  return l10n.formatDate(new Date(dateInput.year, dateInput.month - 1, dateInput.day), {
    raw: "yyyy-MM-dd"
  });
};
var timeInputToString = function (dateInput) {
  if (!dateInput) {
    return null;
  }
  return "".concat(dateInput.hour, ":").concat(dateInput.minute);
};
// src/utils/url-utils.ts
var updateUrlParam = function (filterId, value, urlSearchParams) {
  if (value) {
    urlSearchParams.set(filterId, value);
  } else {
    urlSearchParams.delete(filterId);
  }
};
// src/components/cars/cars-criteria-url-parser.ts
var CARS_DEFAULT_TIME = "10:30";
var CARS_DEFAULT_PICK_UP_DATE = 14;
var CARS_DEFAULT_DROP_OFF_DATE = CARS_DEFAULT_PICK_UP_DATE + 1;
var URL_PARAMS = {
  PICK_UP_LOCATION: {
    SEARCH_TERM: "locn",
    REGION: "dpln",
    EXACT_LOCATION: "exlocn",
    LATITUDE: "olat",
    LONGITUDE: "olon"
  },
  DROP_OFF_LOCATION: {
    SEARCH_TERM: "loc2",
    REGION: "drid1",
    EXACT_LOCATION: "exloc2",
    LATITUDE: "dlat",
    LONGITUDE: "dlon"
  },
  PICK_UP_DATE_TIME: {
    DATE: "date1",
    TIME: "time1"
  },
  DROP_OFF_DATE_TIME: {
    DATE: "date2",
    TIME: "time2"
  }
};
var getCarRentalLocationInput = function (searchTerm, regionId, exactLocation, latitude, longitude) {
  var pickUpCoordinates = !regionId && latitude && longitude ? {
    latitude: Number(latitude),
    longitude: Number(longitude)
  } : void 0;
  var isPickUpExactLoc = Boolean(pickUpCoordinates) || Boolean(exactLocation);
  return {
    searchTerm: searchTerm || void 0,
    regionId: regionId !== null && regionId !== void 0 ? regionId : void 0,
    coordinates: pickUpCoordinates,
    isExactLocationSearch: isPickUpExactLoc
  };
};
var getPickUpLocation = function (urlSearchParams) {
  var pickUpLocationSearchTerm = urlSearchParams.get(URL_PARAMS.PICK_UP_LOCATION.SEARCH_TERM);
  var pickUpRegion = urlSearchParams.get(URL_PARAMS.PICK_UP_LOCATION.REGION);
  var pickUpExactLocation = urlSearchParams.get(URL_PARAMS.PICK_UP_LOCATION.EXACT_LOCATION);
  var pickUpLatitude = urlSearchParams.get(URL_PARAMS.PICK_UP_LOCATION.LATITUDE);
  var pickUpLongitude = urlSearchParams.get(URL_PARAMS.PICK_UP_LOCATION.LONGITUDE);
  return getCarRentalLocationInput(pickUpLocationSearchTerm, pickUpRegion, pickUpExactLocation, pickUpLatitude, pickUpLongitude);
};
var getDropOffLocation = function (urlSearchParams) {
  var dropOffLocationSearchTerm = urlSearchParams.get(URL_PARAMS.DROP_OFF_LOCATION.SEARCH_TERM);
  var dropOffRegion = urlSearchParams.get(URL_PARAMS.DROP_OFF_LOCATION.REGION);
  var dropOffExactLocation = urlSearchParams.get(URL_PARAMS.DROP_OFF_LOCATION.EXACT_LOCATION);
  var dropOffLatitude = urlSearchParams.get(URL_PARAMS.DROP_OFF_LOCATION.LATITUDE);
  var dropOffLongitude = urlSearchParams.get(URL_PARAMS.DROP_OFF_LOCATION.LONGITUDE);
  var dropOffLocation = getCarRentalLocationInput(dropOffLocationSearchTerm, dropOffRegion, dropOffExactLocation, dropOffLatitude, dropOffLongitude);
  return dropOffLocation.regionId || dropOffLocation.searchTerm || dropOffLocation.coordinates ? dropOffLocation : null;
};
var getCarsDefaultDate = function (date) {
  var defaultTimeStamp = /* @__PURE__ */new Date();
  defaultTimeStamp.setDate(defaultTimeStamp.getDate() + date);
  return defaultTimeStamp.toISOString().split("T")[0];
};
var getPickUpDateTime = function (urlSearchParams, l10n, localDateFormat) {
  var pickUpDate = urlSearchParams.get(URL_PARAMS.PICK_UP_DATE_TIME.DATE);
  var pickUpTime = urlSearchParams.get(URL_PARAMS.PICK_UP_DATE_TIME.TIME);
  var isLegacyFormat = pickUpTime && !(pickUpTime === null || pickUpTime === void 0 ? void 0 : pickUpTime.includes(":"));
  var formattedDate = isLegacyFormat ? convertTo24HourFormat(pickUpTime) : pickUpTime;
  return getDateTimeInput(pickUpDate, formattedDate, l10n, getCarsDefaultDate(CARS_DEFAULT_PICK_UP_DATE), CARS_DEFAULT_TIME, localDateFormat);
};
var getDropOffDateTime = function (urlSearchParams, l10n, localDateFormat) {
  var dropOffDate = urlSearchParams.get(URL_PARAMS.DROP_OFF_DATE_TIME.DATE);
  var dropOffTime = urlSearchParams.get(URL_PARAMS.DROP_OFF_DATE_TIME.TIME);
  var isLegacyFormat = dropOffTime && (dropOffTime.includes("AM") || dropOffTime.includes("PM"));
  var formattedDate = isLegacyFormat ? convertTo24HourFormat(dropOffTime) : dropOffTime;
  return getDateTimeInput(dropOffDate, formattedDate, l10n, getCarsDefaultDate(CARS_DEFAULT_DROP_OFF_DATE), CARS_DEFAULT_TIME, localDateFormat);
};
var getCarsPrimarySearchCriteria = function (urlSearchParams, l10n, localDateFormat) {
  var pickUpLocation = getPickUpLocation(urlSearchParams);
  var dropOffLocation = getDropOffLocation(urlSearchParams);
  var pickUpDateTime = getPickUpDateTime(urlSearchParams, l10n, localDateFormat);
  var dropOffDateTime = getDropOffDateTime(urlSearchParams, l10n, localDateFormat);
  return {
    pickUpLocation: pickUpLocation,
    pickUpDateTime: pickUpDateTime,
    dropOffLocation: dropOffLocation,
    dropOffDateTime: dropOffDateTime
  };
};
var getBooleans = function (urlSearchParams) {
  var booleans = [];
  var aarpcrId = "aarpcr";
  if (urlSearchParams.get(aarpcrId) === "on") {
    booleans.push({
      id: aarpcrId,
      value: true
    });
  }
  return booleans;
};
var getAllFilterIds = function (urlSearchParams) {
  var filterIds = ["orid", "oloc", "rdus", "piid", "totalprice", "age", "rfrr"];
  var keyword = "sel";
  var allFilterIds = _to_consumable_array(urlSearchParams.keys()).filter(function (filterId) {
    return filterId.startsWith(keyword) || filterIds.includes(filterId);
  });
  return _to_consumable_array(new Set(allFilterIds));
};
var getFilterSelections = function (urlSearchParams) {
  if (_to_consumable_array(urlSearchParams.keys()).length === 0) {
    return [];
  }
  var filterSelections = [];
  var allFilterIds = getAllFilterIds(urlSearchParams);
  allFilterIds.forEach(function (filterId) {
    var value = urlSearchParams.get(filterId);
    if (value) {
      if (value.includes("[")) {
        var values = JSON.parse(value);
        values.forEach(function (val) {
          filterSelections.push({
            id: filterId,
            value: val
          });
        });
      } else if (filterId === "piid") {
        filterSelections.push({
          id: "carOfferToken",
          value: value
        });
      } else {
        filterSelections.push({
          id: filterId,
          value: value
        });
      }
    }
  });
  return filterSelections;
};
var getDiscountCodeCriteriaSelections = function (urlSearchParams) {
  var discountCodeCriteriaSelections = [];
  var corporateDiscountCode = urlSearchParams.get("cdnu");
  var promoCode = urlSearchParams.get("cpcd");
  var rateCode = urlSearchParams.get("rtcd");
  var loyaltyProgramCode = urlSearchParams.get("odcd");
  if (corporateDiscountCode) {
    discountCodeCriteriaSelections.push({
      id: "corporateDiscountCode",
      value: corporateDiscountCode
    });
  }
  if (promoCode) {
    discountCodeCriteriaSelections.push({
      id: "promoCode",
      value: promoCode
    });
  }
  if (rateCode) {
    discountCodeCriteriaSelections.push({
      id: "rateCode",
      value: rateCode
    });
  }
  if (loyaltyProgramCode) {
    discountCodeCriteriaSelections.push({
      id: "loyaltyProgramCode",
      value: loyaltyProgramCode
    });
  }
  return discountCodeCriteriaSelections;
};
var getSelections = function (urlSearchParams) {
  var filterSelections = getFilterSelections(urlSearchParams);
  var discountCodeCriteriaSelections = getDiscountCodeCriteriaSelections(urlSearchParams);
  return _to_consumable_array(filterSelections).concat(_to_consumable_array(discountCodeCriteriaSelections));
};
var getCarsSearchCriteriaFromQueryParams = function (urlSearchParams, l10n, localDateFormat) {
  return {
    primarySearchCriteria: {
      car: getCarsPrimarySearchCriteria(urlSearchParams, l10n, localDateFormat)
    },
    secondaryCriteria: {
      booleans: getBooleans(urlSearchParams),
      selections: getSelections(urlSearchParams)
    }
  };
};
var changeFilterSelection = function (filterId, value, state) {
  var _state_secondaryCriteria;
  var currentSelections = ((_state_secondaryCriteria = state.secondaryCriteria) === null || _state_secondaryCriteria === void 0 ? void 0 : _state_secondaryCriteria.selections) || [];
  var newSelections = currentSelections.filter(function (selection) {
    return selection.id !== filterId;
  });
  if (value) {
    newSelections.push({
      id: filterId,
      value: value
    });
  }
  return _to_consumable_array(newSelections);
};
var addSelection = function (filterId, value, state) {
  var _state_secondaryCriteria;
  var currentSelections = ((_state_secondaryCriteria = state.secondaryCriteria) === null || _state_secondaryCriteria === void 0 ? void 0 : _state_secondaryCriteria.selections) || [];
  if (currentSelections.some(function (selection) {
    return selection.id === filterId && selection.value === value;
  })) {
    return _to_consumable_array(currentSelections);
  }
  return _to_consumable_array(currentSelections).concat([{
    id: filterId,
    value: value
  }]);
};
var removeSelection = function (filterId, value, state) {
  var _state_secondaryCriteria;
  var currentSelections = ((_state_secondaryCriteria = state.secondaryCriteria) === null || _state_secondaryCriteria === void 0 ? void 0 : _state_secondaryCriteria.selections) || [];
  return _to_consumable_array(currentSelections.filter(function (selection) {
    return selection.id !== filterId || selection.id === filterId && selection.value !== value;
  }));
};
var updateFilterSelections = function (field, event, state) {
  var filterId = field.name,
    value = field.value;
  var _event_target = event.target,
    type = _event_target.type,
    checked = _event_target.checked;
  switch (type) {
    case "checkbox":
      {
        var selections = checked ? addSelection(filterId, value, state) : removeSelection(filterId, value, state);
        return _object_spread_props(_object_spread({}, state), {
          secondaryCriteria: _object_spread_props(_object_spread({}, state.secondaryCriteria), {
            selections: selections
          })
        });
      }
    case "radio":
      {
        var newSelections = changeFilterSelection(filterId, value, state);
        return _object_spread_props(_object_spread({}, state), {
          secondaryCriteria: _object_spread_props(_object_spread({}, state.secondaryCriteria), {
            selections: newSelections
          })
        });
      }
    default:
      {
        return state;
      }
  }
};
var addItemToUrlParams = function (filterId, value, urlSearchParams) {
  var currentValues = urlSearchParams.getAll(filterId);
  if (!currentValues.includes(value)) {
    urlSearchParams.append(filterId, value);
  }
  return urlSearchParams.toString();
};
var removeItemFromUrlParams = function (filterId, value, urlSearchParams) {
  var currentValues = urlSearchParams.getAll(filterId);
  if (currentValues.includes(value)) {
    urlSearchParams.delete(filterId);
    currentValues.forEach(function (val) {
      if (val !== value) {
        urlSearchParams.append(filterId, val);
      }
    });
  }
  return urlSearchParams.toString();
};
var changeUrlParam = function (filterId, value, urlSearchParams) {
  if (value) {
    urlSearchParams.set(filterId, value);
  } else {
    urlSearchParams.delete(filterId);
  }
  return urlSearchParams.toString();
};
var updateUrlParams = function (field, event, urlSearchParams) {
  var filterId = field.name,
    value = field.value;
  var _event_target = event.target,
    type = _event_target.type,
    checked = _event_target.checked;
  switch (type) {
    case "checkbox":
      {
        return checked ? addItemToUrlParams(filterId, value, urlSearchParams) : removeItemFromUrlParams(filterId, value, urlSearchParams);
      }
    case "radio":
      {
        return changeUrlParam(filterId, value, urlSearchParams);
      }
    default:
      {
        return urlSearchParams.toString();
      }
  }
};
var updateUrlParamsPrimaryCriteria = function (state, l10n, urlSearchParams) {
  var _pickUpLocation_isExactLocationSearch, _pickUpLocation_coordinates_latitude, _pickUpLocation_coordinates, _pickUpLocation_coordinates_longitude, _pickUpLocation_coordinates1, _dropOffLocation_isExactLocationSearch, _dropOffLocation_coordinates_latitude, _dropOffLocation_coordinates, _dropOffLocation_coordinates_longitude, _dropOffLocation_coordinates1;
  urlSearchParams.delete("pwaDialog");
  var pickUpLocation = state === null || state === void 0 ? void 0 : state.pickUpLocation;
  updateUrlParam(URL_PARAMS.PICK_UP_LOCATION.SEARCH_TERM, pickUpLocation === null || pickUpLocation === void 0 ? void 0 : pickUpLocation.searchTerm, urlSearchParams);
  updateUrlParam(URL_PARAMS.PICK_UP_LOCATION.EXACT_LOCATION, pickUpLocation === null || pickUpLocation === void 0 ? void 0 : (_pickUpLocation_isExactLocationSearch = pickUpLocation.isExactLocationSearch) === null || _pickUpLocation_isExactLocationSearch === void 0 ? void 0 : _pickUpLocation_isExactLocationSearch.toString(), urlSearchParams);
  updateUrlParam(URL_PARAMS.PICK_UP_LOCATION.REGION, pickUpLocation === null || pickUpLocation === void 0 ? void 0 : pickUpLocation.regionId, urlSearchParams);
  updateUrlParam(URL_PARAMS.PICK_UP_LOCATION.LATITUDE, pickUpLocation === null || pickUpLocation === void 0 ? void 0 : (_pickUpLocation_coordinates = pickUpLocation.coordinates) === null || _pickUpLocation_coordinates === void 0 ? void 0 : (_pickUpLocation_coordinates_latitude = _pickUpLocation_coordinates.latitude) === null || _pickUpLocation_coordinates_latitude === void 0 ? void 0 : _pickUpLocation_coordinates_latitude.toString(), urlSearchParams);
  updateUrlParam(URL_PARAMS.PICK_UP_LOCATION.LONGITUDE, pickUpLocation === null || pickUpLocation === void 0 ? void 0 : (_pickUpLocation_coordinates1 = pickUpLocation.coordinates) === null || _pickUpLocation_coordinates1 === void 0 ? void 0 : (_pickUpLocation_coordinates_longitude = _pickUpLocation_coordinates1.longitude) === null || _pickUpLocation_coordinates_longitude === void 0 ? void 0 : _pickUpLocation_coordinates_longitude.toString(), urlSearchParams);
  var pickUpDateTime = state === null || state === void 0 ? void 0 : state.pickUpDateTime;
  updateUrlParam(URL_PARAMS.PICK_UP_DATE_TIME.DATE, dateInputToString(pickUpDateTime, l10n), urlSearchParams);
  updateUrlParam(URL_PARAMS.PICK_UP_DATE_TIME.TIME, timeInputToString(pickUpDateTime), urlSearchParams);
  var dropOffLocation = state === null || state === void 0 ? void 0 : state.dropOffLocation;
  updateUrlParam(URL_PARAMS.DROP_OFF_LOCATION.SEARCH_TERM, dropOffLocation === null || dropOffLocation === void 0 ? void 0 : dropOffLocation.searchTerm, urlSearchParams);
  updateUrlParam(URL_PARAMS.DROP_OFF_LOCATION.EXACT_LOCATION, dropOffLocation === null || dropOffLocation === void 0 ? void 0 : (_dropOffLocation_isExactLocationSearch = dropOffLocation.isExactLocationSearch) === null || _dropOffLocation_isExactLocationSearch === void 0 ? void 0 : _dropOffLocation_isExactLocationSearch.toString(), urlSearchParams);
  updateUrlParam(URL_PARAMS.DROP_OFF_LOCATION.REGION, dropOffLocation === null || dropOffLocation === void 0 ? void 0 : dropOffLocation.regionId, urlSearchParams);
  updateUrlParam(URL_PARAMS.DROP_OFF_LOCATION.LATITUDE, dropOffLocation === null || dropOffLocation === void 0 ? void 0 : (_dropOffLocation_coordinates = dropOffLocation.coordinates) === null || _dropOffLocation_coordinates === void 0 ? void 0 : (_dropOffLocation_coordinates_latitude = _dropOffLocation_coordinates.latitude) === null || _dropOffLocation_coordinates_latitude === void 0 ? void 0 : _dropOffLocation_coordinates_latitude.toString(), urlSearchParams);
  updateUrlParam(URL_PARAMS.DROP_OFF_LOCATION.LONGITUDE, dropOffLocation === null || dropOffLocation === void 0 ? void 0 : (_dropOffLocation_coordinates1 = dropOffLocation.coordinates) === null || _dropOffLocation_coordinates1 === void 0 ? void 0 : (_dropOffLocation_coordinates_longitude = _dropOffLocation_coordinates1.longitude) === null || _dropOffLocation_coordinates_longitude === void 0 ? void 0 : _dropOffLocation_coordinates_longitude.toString(), urlSearchParams);
  var dropOffDateTime = state === null || state === void 0 ? void 0 : state.dropOffDateTime;
  updateUrlParam(URL_PARAMS.DROP_OFF_DATE_TIME.DATE, dateInputToString(dropOffDateTime, l10n), urlSearchParams);
  updateUrlParam(URL_PARAMS.DROP_OFF_DATE_TIME.TIME, timeInputToString(dropOffDateTime), urlSearchParams);
  return urlSearchParams.toString();
};
// src/components/cars/cars-criteria-reducer.ts
var useCarsSearchCriteriaReducer = function (localDateFormat) {
  var location = useLocation();
  var history = useHistory();
  var l10n = useLocalization();
  return React2.useReducer(function (state, action) {
    var urlSearchParams = new URLSearchParams(location.search);
    switch (action.type) {
      case 0 /* READ_PARAMS_FROM_URL */:
        {
          return getCarsSearchCriteriaFromQueryParams(action.urlSearchParams, l10n, localDateFormat);
        }
      case 3 /* FILTER_UPDATE */:
        {
          var field = action.field,
            event = action.event;
          var search = updateUrlParams(field, event, urlSearchParams);
          history.push(_object_spread_props(_object_spread({}, location), {
            search: search
          }));
          return updateFilterSelections(field, event, state);
        }
      case 4 /* SEARCH_FORM_UPDATE */:
        {
          var updatedPrimarySearchCriteria = action.updatedPrimarySearchCriteria;
          var search1 = updateUrlParamsPrimaryCriteria(updatedPrimarySearchCriteria.car, l10n, urlSearchParams);
          history.push(_object_spread_props(_object_spread({}, location), {
            search: search1
          }));
          return {
            primarySearchCriteria: updatedPrimarySearchCriteria,
            secondaryCriteria: state.secondaryCriteria
          };
        }
      default:
        {
          return state;
        }
    }
  }, getCarsSearchCriteriaFromQueryParams(new URLSearchParams(location.search), l10n, localDateFormat));
};
// src/components/cars/cars-criteria-provider.tsx
var CarsCriteriaProvider = function (param) {
  var children = param.children,
    localDateFormat = param.localDateFormat;
  var _useCarsSearchCriteriaReducer = _sliced_to_array(useCarsSearchCriteriaReducer(localDateFormat), 2),
    carsProductShoppingCriteriaInputState = _useCarsSearchCriteriaReducer[0],
    dispatch = _useCarsSearchCriteriaReducer[1];
  return /* @__PURE__ */React3.createElement(CarsCriteriaContext.Provider, {
    value: carsProductShoppingCriteriaInputState
  }, /* @__PURE__ */React3.createElement(CarsCriteriaDispatchContext.Provider, {
    value: dispatch
  }, children));
};
// src/components/cars/cars-criteria-consumer.tsx
import React6 from "react";
// src/components/product/product-shopping-criteria-context.ts
import React4 from "react";
var ProductShoppingCriteriaContext = React4.createContext(null);
var ProductShoppingCriteriaDispatchContext = React4.createContext(null);
// src/components/cars/cars-criteria-hooks.ts
import React5 from "react";
var useCarsCriteria = function () {
  return React5.useContext(CarsCriteriaContext);
};
var useCarsCriteriaDispatch = function () {
  var dispatch = React5.useContext(CarsCriteriaDispatchContext);
  if (!dispatch) {
    throw new Error("useCarsCriteriaDispatch can only be used inside CarsCriteriaProvider");
  }
  return dispatch;
};
// src/components/cars/cars-criteria-consumer.tsx
var CarsCriteriaConsumer = function (param) {
  var children = param.children;
  var carsCriteria = useCarsCriteria();
  var carsCriteriaDispatch = useCarsCriteriaDispatch();
  return /* @__PURE__ */React6.createElement(ProductShoppingCriteriaContext.Provider, {
    value: carsCriteria
  }, /* @__PURE__ */React6.createElement(ProductShoppingCriteriaDispatchContext.Provider, {
    value: carsCriteriaDispatch
  }, children));
};
CarsCriteriaConsumer.displayName = "sharedui-CarsCriteriaConsumer";
// src/components/cruise/cruise-criteria-hooks.ts
import React8 from "react";
// src/components/cruise/cruise-criteria-context.ts
import React7 from "react";
var CruiseCriteriaContext = React7.createContext(null);
var CruiseCriteriaDispatchContext = React7.createContext(null);
// src/components/cruise/cruise-criteria-hooks.ts
var useCruiseCriteria = function () {
  return React8.useContext(CruiseCriteriaContext);
};
var useCruiseCriteriaDispatch = function () {
  var dispatch = React8.useContext(CruiseCriteriaDispatchContext);
  if (!dispatch) {
    throw new Error("useCruiseCriteriaDispatch can only be used inside CruiseCriteriaProvider");
  }
  return dispatch;
};
// src/components/cruise/cruise-criteria-provider.tsx
import React10 from "react";
import { useLocation as useLocation3 } from "react-router-dom";
// src/components/cruise/cruise-criteria-reducer.ts
import React9 from "react";
import { useHistory as useHistory2, useLocation as useLocation2 } from "react-router-dom";
// src/utils/cruise-query-params.ts
var ClearableCruiseFilterParams = /* @__PURE__ */function (ClearableCruiseFilterParams2) {
  ClearableCruiseFilterParams2["SAILING_VARIETIES"] = "sailing-varieties" /* SAILING_VARIETIES */;
  ClearableCruiseFilterParams2["CABIN_EXPERIENCE"] = "cabin-experience" /* CABIN_EXPERIENCE */;
  ClearableCruiseFilterParams2["DEPARTURE_PORT"] = "departure-port" /* DEPARTURE_PORT */;
  ClearableCruiseFilterParams2["CRUISE_LINE"] = "cruise-line" /* CRUISE_LINE */;
  ClearableCruiseFilterParams2["SHIPS"] = "ships" /* SHIPS */;
  return ClearableCruiseFilterParams2;
}(ClearableCruiseFilterParams || {});
var DEFAULT_DESTINATIONS = ["alaska", "bahamas", "caribbean", "europe", "mexico"];
var DEFAULT_END_DATE_FROM_START_DATE = 30;
var getList = function (urlSearchParams, key) {
  var delimiter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "|";
  var values = [];
  var urlValues = _to_consumable_array(new Set(urlSearchParams.getAll(key))).reduce(function (previousValue, currentValue) {
    currentValue.split(delimiter).forEach(function (value) {
      previousValue.push(value);
    });
    return previousValue;
  }, values);
  return urlValues.length ? values : null;
};
var getInt = function (queryParams, param) {
  var value = queryParams.get(param);
  var parsedValue = parseInt(value || "", 10);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};
var getDefaultDates = function () {
  var today = /* @__PURE__ */new Date();
  var defaultEndDate = /* @__PURE__ */new Date();
  defaultEndDate.setDate(today.getDate() + DEFAULT_END_DATE_FROM_START_DATE);
  return {
    start: dateToDateInput(today),
    end: dateToDateInput(defaultEndDate)
  };
};
var getDepartureDateRange = function (queryParams) {
  var earliestDepartureDate = queryParams.get("earliest-departure-date" /* EARLIEST_DEPARTURE_DATE */);
  var latestDepartureDate = queryParams.get("latest-departure-date" /* LATEST_DEPARTURE_DATE */);
  if (earliestDepartureDate && latestDepartureDate) {
    return {
      start: isoDateToDateInput(earliestDepartureDate),
      end: isoDateToDateInput(latestDepartureDate)
    };
  }
  return getDefaultDates();
};
var getDurationRange = function (queryParams) {
  var minLength = getInt(queryParams, "min-length" /* MIN_LENGTH */);
  var maxLength = getInt(queryParams, "max-length" /* MAX_LENGTH */);
  if (minLength && maxLength) {
    return {
      min: minLength,
      max: maxLength
    };
  }
  return null;
};
var getChildAges = function (queryParams) {
  var _ages_map;
  var ages = getList(queryParams, "childAges" /* CHILD_AGES */, ",");
  var _ages_map_filter;
  return (_ages_map_filter = ages === null || ages === void 0 ? void 0 : (_ages_map = ages.map(function (childAge) {
    return {
      age: parseInt(childAge, 10)
    };
  })) === null || _ages_map === void 0 ? void 0 : _ages_map.filter(function (param) {
    var age = param.age;
    return Number.isInteger(age);
  })) !== null && _ages_map_filter !== void 0 ? _ages_map_filter : null;
};
var getSelectionValues = function (values, id) {
  if (!values || values.length === 0) {
    return [];
  }
  return values.map(function (value) {
    return {
      id: id,
      value: value
    };
  });
};
var sortParamsMap = /* @__PURE__ */new Map().set("price|asc", "PRICE_LOW_TO_HIGH").set("price|desc", "PRICE_HIGH_TO_LOW").set("departure-date|asc", "DEPARTURE_EARLY_TO_LATE").set("departure-date|desc", "DEPARTURE_LATE_TO_EARLY").set("duration|asc", "DURATION_SHORT_TO_LONG").set("duration|desc", "DURATION_LONG_TO_SHORT");
var convertSortParam = function (queryParams) {
  var _sortParamsMap_get;
  return (_sortParamsMap_get = sortParamsMap.get("".concat(queryParams.get("sort-by" /* SORT_BY */), "|").concat(queryParams.get("sort-order" /* SORT_ORDER */)))) !== null && _sortParamsMap_get !== void 0 ? _sortParamsMap_get : "";
};
var getSelections2 = function (queryParams) {
  var _queryParams_get;
  return _to_consumable_array(getSelectionValues(getList(queryParams, "sailing-varieties" /* SAILING_VARIETIES */), "sailing-varieties" /* SAILING_VARIETIES */)).concat(_to_consumable_array(getSelectionValues(getList(queryParams, "sailing-token" /* SAILING_TOKEN */), "sailing-token" /* SAILING_TOKEN */)), _to_consumable_array(getSelectionValues(getList(queryParams, "cabin-experience" /* CABIN_EXPERIENCE */), "cabin-experience" /* CABIN_EXPERIENCE */)), _to_consumable_array(getSelectionValues(getList(queryParams, "departure-port" /* DEPARTURE_PORT */), "departure-port" /* DEPARTURE_PORT */)), _to_consumable_array(getSelectionValues(getList(queryParams, "cruise-line" /* CRUISE_LINE */), "cruise-line" /* CRUISE_LINE */)), _to_consumable_array(getSelectionValues(getList(queryParams, "ships" /* SHIPS */), "ships" /* SHIPS */)), [{
    id: "sort" /* SORT */,
    value: (_queryParams_get = queryParams.get("sort" /* SORT */)) !== null && _queryParams_get !== void 0 ? _queryParams_get : convertSortParam(queryParams)
  }]);
};
var getCruiseSearchCriteriaFromQueryParams = function (queryParams) {
  var _getList;
  return {
    primarySearchCriteria: {
      cruise: {
        adultCount: getInt(queryParams, "adultCount" /* ADULT_COUNT */),
        childCount: getInt(queryParams, "childCount" /* CHILD_COUNT */),
        children: getChildAges(queryParams),
        departureDateRange: getDepartureDateRange(queryParams),
        destinations: (_getList = getList(queryParams, "destination" /* DESTINATION */)) !== null && _getList !== void 0 ? _getList : DEFAULT_DESTINATIONS,
        durationRange: getDurationRange(queryParams)
      }
    },
    secondaryCriteria: {
      selections: getSelections2(queryParams)
    }
  };
};
var getUpdatedMultiTypeaheadSelections = function (filterId, currentSelections, secondaryCriteria) {
  var _secondaryCriteria_selections;
  var newSecondarySelections = [];
  currentSelections === null || currentSelections === void 0 ? void 0 : currentSelections.reduce(function (accumulator, currentValue) {
    var value = currentValue.data.value;
    if (value) {
      accumulator.push({
        id: filterId,
        value: value
      });
    }
    return accumulator;
  }, newSecondarySelections);
  var otherSelections = (secondaryCriteria === null || secondaryCriteria === void 0 ? void 0 : (_secondaryCriteria_selections = secondaryCriteria.selections) === null || _secondaryCriteria_selections === void 0 ? void 0 : _secondaryCriteria_selections.filter(function (selection) {
    return selection.id !== filterId;
  })) || [];
  return _to_consumable_array(otherSelections).concat(_to_consumable_array(newSecondarySelections));
};
var getNewSelectionValue = function (filterId, secondaryCriteria) {
  var _secondaryCriteria_selections;
  var selections = [];
  secondaryCriteria === null || secondaryCriteria === void 0 ? void 0 : (_secondaryCriteria_selections = secondaryCriteria.selections) === null || _secondaryCriteria_selections === void 0 ? void 0 : _secondaryCriteria_selections.reduce(function (accumulator, currentValue) {
    if (currentValue.id === filterId) {
      accumulator.push(currentValue.value);
    }
    return accumulator;
  }, selections);
  if (selections.length === 0) {
    return null;
  }
  return selections.join("|");
};
// src/components/cruise/cruise-criteria-reducer.ts
var useCruiseCriteriaReducer = function () {
  var location = useLocation2();
  var history = useHistory2();
  return React9.useReducer(function (state, action) {
    var urlSearchParams = new URLSearchParams(location.search);
    switch (action.type) {
      case 0 /* READ_PARAMS_FROM_URL */:
        {
          return getCruiseSearchCriteriaFromQueryParams(action.urlSearchParams);
        }
      case 1 /* MULTI_SELECT_CLEAR_ALL */:
        {
          var _state_secondaryCriteria_selections, _state_secondaryCriteria;
          var filterId = action.filterId;
          var otherSelections = ((_state_secondaryCriteria = state.secondaryCriteria) === null || _state_secondaryCriteria === void 0 ? void 0 : (_state_secondaryCriteria_selections = _state_secondaryCriteria.selections) === null || _state_secondaryCriteria_selections === void 0 ? void 0 : _state_secondaryCriteria_selections.filter(function (selection) {
            return selection.id !== filterId;
          })) || [];
          urlSearchParams.delete(filterId);
          history.push(_object_spread_props(_object_spread({}, location), {
            search: urlSearchParams.toString()
          }));
          return _object_spread_props(_object_spread({}, state), {
            secondaryCriteria: _object_spread_props(_object_spread({}, state.secondaryCriteria), {
              selections: otherSelections
            })
          });
        }
      case 2 /* MULTI_SELECT_CLOSE */:
        {
          var filterId1 = action.filterId,
            selections = action.selections;
          var newSecondaryCriteria = _object_spread_props(_object_spread({}, state.secondaryCriteria), {
            selections: getUpdatedMultiTypeaheadSelections(filterId1, selections, state.secondaryCriteria)
          });
          var value = getNewSelectionValue(filterId1, newSecondaryCriteria);
          if (value) {
            urlSearchParams.set(filterId1, value);
          }
          history.push(_object_spread_props(_object_spread({}, location), {
            search: urlSearchParams.toString()
          }));
          return _object_spread_props(_object_spread({}, state), {
            secondaryCriteria: newSecondaryCriteria
          });
        }
      default:
        {
          return state;
        }
    }
  }, getCruiseSearchCriteriaFromQueryParams(new URLSearchParams(location.search)));
};
// src/components/cruise/cruise-criteria-provider.tsx
var CruiseCriteriaProvider = function (param) {
  var children = param.children;
  var location = useLocation3();
  var _useCruiseCriteriaReducer = _sliced_to_array(useCruiseCriteriaReducer(), 2),
    cruiseProductShoppingCriteriaInputState = _useCruiseCriteriaReducer[0],
    dispatch = _useCruiseCriteriaReducer[1];
  React10.useEffect(function () {
    dispatch({
      type: 0 /* READ_PARAMS_FROM_URL */,
      urlSearchParams: new URLSearchParams(location.search)
    });
  }, [location.search, dispatch]);
  return /* @__PURE__ */React10.createElement(CruiseCriteriaContext.Provider, {
    value: cruiseProductShoppingCriteriaInputState
  }, /* @__PURE__ */React10.createElement(CruiseCriteriaDispatchContext.Provider, {
    value: dispatch
  }, children));
};
CruiseCriteriaProvider.displayName = "sharedui-CruiseCriteriaProvider";
// src/components/ground-transportation/ground-transportation-criteria-provider.tsx
import React11 from "react";
import { useLocation as useLocation4 } from "react-router-dom";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
// src/utils/ground-transportation-query-params.ts
var GT_DEFAULT_TIME = "10:30";
var SHOP_WITH_POINTS = "swp";
var SORT = "sort";
var FILTER = "filter";
var ClearableGTFilterParams = /* @__PURE__ */function (ClearableGTFilterParams2) {
  ClearableGTFilterParams2["FILTER_CATEGORIES"] = "filterCategories";
  return ClearableGTFilterParams2;
}(ClearableGTFilterParams || {});
function getSearchDirection(roundTrip, direction) {
  if (roundTrip === "true") {
    return "ROUNDTRIP" /* ROUNDTRIP */;
  }
  switch (direction) {
    case "H2A":
    case "TO_AIRPORT" /* TO_AIRPORT */:
      return "TO_AIRPORT" /* TO_AIRPORT */;
    default:
      return "FROM_AIRPORT" /* FROM_AIRPORT */;
  }
}
function getCoordinates(latLong) {
  if (!latLong) {
    return null;
  }
  var _latLong_split = _sliced_to_array(latLong.split(","), 2),
    latitude = _latLong_split[0],
    longitude = _latLong_split[1];
  return latitude && longitude ? {
    latitude: Number(latitude),
    longitude: Number(longitude)
  } : null;
}
var getGtDefaultDate = function () {
  var defaultTimeStamp = /* @__PURE__ */new Date();
  defaultTimeStamp.setDate(defaultTimeStamp.getDate() + 14);
  return defaultTimeStamp.toISOString().split("T")[0];
};
function getHotelData(urlParams) {
  var hotelId = urlParams.hotelId,
    hotelName = urlParams.hotelName,
    hotelLatLong = urlParams.hotelLatLong;
  return {
    id: hotelId,
    name: hotelName,
    coordinates: getCoordinates(hotelLatLong),
    type: "PROPERTY" /* PROPERTY */
  };
}
function getAirportData(urlParams) {
  var airportCode = urlParams.airportCode,
    location = urlParams.location,
    airportLatLong = urlParams.airportLatLong,
    regionId = urlParams.regionId;
  return airportCode ? {
    id: airportCode,
    name: location,
    coordinates: getCoordinates(airportLatLong),
    type: "AIRPORT" /* AIRPORT */
  } : {
    id: regionId,
    name: location,
    type: "DESTINATION" /* DESTINATION */
  };
}
function getTravelersDetails(urlParams) {
  var adults = urlParams.adults,
    children = urlParams.children,
    infants = urlParams.infants;
  var travelerDetails = [];
  if (adults) {
    travelerDetails.push({
      type: "ADULT" /* ADULT */,
      count: parseInt(adults, 10)
    });
  }
  if (children) {
    travelerDetails.push({
      type: "CHILD" /* CHILD */,
      count: parseInt(children, 10)
    });
  }
  if (infants) {
    travelerDetails.push({
      type: "INFANT" /* INFANT */,
      count: parseInt(infants, 10)
    });
  }
  return travelerDetails;
}
function getPrimarySearchCriteria(urlSearchParams, l10n, localDateFormat) {
  var urlParams = Object.fromEntries(urlSearchParams);
  var direction = urlParams.direction,
    roundTrip = urlParams.roundTrip,
    pickUpDate = urlParams.pickUpDate,
    pickUpTime = urlParams.pickUpTime,
    dropOffDate = urlParams.dropOffDate,
    dropOffTime = urlParams.dropOffTime;
  var searchDirection = getSearchDirection(roundTrip, direction);
  var toAirport = searchDirection === "TO_AIRPORT" /* TO_AIRPORT */;
  var journeyCriteria = [];
  var travelerDetails = getTravelersDetails(urlParams);
  var onwardJourney = {
    dateTime: getDateTimeInput(pickUpDate, pickUpTime, l10n, getGtDefaultDate(), GT_DEFAULT_TIME, localDateFormat),
    origin: toAirport ? getHotelData(urlParams) : getAirportData(urlParams),
    destination: toAirport ? getAirportData(urlParams) : getHotelData(urlParams)
  };
  journeyCriteria.push(onwardJourney);
  if (urlParams.roundTrip === "true") {
    var departureDate = dropOffDate !== null && dropOffDate !== void 0 ? dropOffDate : pickUpDate;
    var departureTime = dropOffTime !== null && dropOffTime !== void 0 ? dropOffTime : pickUpTime;
    var returnJourney = {
      dateTime: getDateTimeInput(departureDate, departureTime, l10n, getGtDefaultDate(), GT_DEFAULT_TIME, localDateFormat),
      origin: getHotelData(urlParams),
      destination: getAirportData(urlParams)
    };
    journeyCriteria.push(returnJourney);
  }
  return {
    journeyCriteria: journeyCriteria,
    shoppingPath: "STANDALONE" /* STANDALONE */,
    travelerDetails: travelerDetails,
    dateRange: {},
    // deprecated
    direction: searchDirection !== null && searchDirection !== void 0 ? searchDirection : "FROM_AIRPORT" /* FROM_AIRPORT */,

    // deprecated
    locations: []
  };
}
var getAllKeysWithKeyword = function (keyword, urlParams) {
  var allKeysWithKeyword = _to_consumable_array(urlParams.keys()).filter(function (key) {
    return key.indexOf(keyword) > -1;
  });
  return _to_consumable_array(new Set(allKeysWithKeyword));
};
var getSelections3 = function (urlSearchParams) {
  if (_to_consumable_array(urlSearchParams.keys()).length === 0) {
    return null;
  }
  var selections = [];
  var allFilterKeys = getAllKeysWithKeyword(FILTER, urlSearchParams);
  var _urlSearchParams_get;
  selections.push({
    id: SORT,
    value: (_urlSearchParams_get = urlSearchParams.get("sort")) !== null && _urlSearchParams_get !== void 0 ? _urlSearchParams_get : ""
  });
  allFilterKeys.forEach(function (key) {
    var values = _to_consumable_array(new Set(urlSearchParams.getAll(key)));
    if (values.length) {
      values.forEach(function (value) {
        if (value) {
          selections.push({
            id: key,
            value: value
          });
        }
      });
    }
  });
  return selections;
};
var getSecondarySearchCriteria = function (urlSearchParams) {
  return {
    booleans: [{
      id: SHOP_WITH_POINTS,
      value: urlSearchParams.get(SHOP_WITH_POINTS) !== "false"
    }],
    selections: getSelections3(urlSearchParams)
  };
};
// src/components/ground-transportation/ground-transportation-criteria-provider.tsx
var GroundTransportationCriteriaContext = React11.createContext([null, null]);
var useGroundTransportationCriteria = function () {
  return React11.useContext(GroundTransportationCriteriaContext);
};
var GroundTransportationCriteriaProvider = function (param) {
  var children = param.children,
    localDateFormat = param.localDateFormat;
  var l10n = useLocalization2();
  var location = useLocation4();
  var groundTransportationCriteriaContextValue = React11.useMemo(function () {
    var urlSearchParams = new URLSearchParams(location.search);
    var primaryGroundTransportationCriteria = getPrimarySearchCriteria(urlSearchParams, l10n, localDateFormat);
    var secondaryCriteria = getSecondarySearchCriteria(urlSearchParams);
    return [primaryGroundTransportationCriteria, secondaryCriteria];
  }, [location.search, l10n, localDateFormat]);
  return /* @__PURE__ */React11.createElement(GroundTransportationCriteriaContext.Provider, {
    value: groundTransportationCriteriaContextValue
  }, children);
};
GroundTransportationCriteriaProvider.displayName = "sharedui-GroundTransportationCriteriaProvider";
// src/components/product/product-shopping-criteria-consumers.tsx
import React12 from "react";
var GroundTransportationCriteriaConsumer = function (param) {
  var children = param.children;
  var _useGroundTransportationCriteria = _sliced_to_array(useGroundTransportationCriteria(), 2),
    primaryGroundTransportationCriteria = _useGroundTransportationCriteria[0],
    secondaryCriteria = _useGroundTransportationCriteria[1];
  var productShoppingCriteria = React12.useMemo(function () {
    return {
      primarySearchCriteria: {
        groundTransportation: primaryGroundTransportationCriteria
      },
      secondaryCriteria: secondaryCriteria
    };
  }, [primaryGroundTransportationCriteria, secondaryCriteria]);
  return /* @__PURE__ */React12.createElement(ProductShoppingCriteriaContext.Provider, {
    value: productShoppingCriteria
  }, children);
};
var CruiseCriteriaConsumer = function (param) {
  var children = param.children;
  var cruiseCriteria = useCruiseCriteria();
  var cruiseCriteriaDispatch = useCruiseCriteriaDispatch();
  return /* @__PURE__ */React12.createElement(ProductShoppingCriteriaContext.Provider, {
    value: cruiseCriteria
  }, /* @__PURE__ */React12.createElement(ProductShoppingCriteriaDispatchContext.Provider, {
    value: cruiseCriteriaDispatch
  }, children));
};
GroundTransportationCriteriaConsumer.displayName = "sharedui-GroundTransportationCriteriaConsumer";
CruiseCriteriaConsumer.displayName = "sharedui-CruiseCriteriaConsumer";
// src/components/product/product-shopping-criteria-provider.tsx
var __PropertySearchQuery = gql(_templateObject());
var _obj;
var productShoppingCriteriaProviderMap = (_obj = {}, _define_property(_obj, ProductType.GroundTransportation, GroundTransportationCriteriaProvider), _define_property(_obj, ProductType.Cruise, CruiseCriteriaProvider), _define_property(_obj, ProductType.Cars, CarsCriteriaProvider), _obj);
var _obj1;
var productShoppingCriteriaConsumerMap = (_obj1 = {}, _define_property(_obj1, ProductType.GroundTransportation, GroundTransportationCriteriaConsumer), _define_property(_obj1, ProductType.Cruise, CruiseCriteriaConsumer), _define_property(_obj1, ProductType.Cars, CarsCriteriaConsumer), _obj1);
var ProductShoppingCriteriaProvider = function (param) {
  var children = param.children,
    localDateFormat = param.localDateFormat;
  var productType = useProductType();
  var ShoppingCriteriaProvider = productType ? productShoppingCriteriaProviderMap[productType] : React13.Fragment;
  var ShoppingCriteriaConsumer = productType ? productShoppingCriteriaConsumerMap[productType] : React13.Fragment;
  return /* @__PURE__ */React13.createElement(ShoppingCriteriaProvider, {
    localDateFormat: localDateFormat
  }, /* @__PURE__ */React13.createElement(ShoppingCriteriaConsumer, null, children));
};
ProductShoppingCriteriaProvider.displayName = "sharedui-ProductShoppingCriteriaProvider";
// src/components/product/product-shopping-criteria-hooks.ts
import React14 from "react";
var useProductShoppingCriteria = function () {
  return React14.useContext(ProductShoppingCriteriaContext);
};
var useProductShoppingCriteriaDispatch = function () {
  var dispatch = React14.useContext(ProductShoppingCriteriaDispatchContext);
  if (!dispatch) {
    return function () {};
  }
  return dispatch;
};
// src/components/flights/flight-criteria-provider.tsx
import React15, { createContext, useContext, useMemo } from "react";
import { useLocation as useLocation5 } from "react-router-dom";
import { gql as gql2 } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/utils/flight-query-params.ts
var mapTripType = function (trip) {
  switch (trip) {
    case "oneway":
      return "ONE_WAY" /* ONE_WAY */;
    case "roundtrip":
      return "ROUND_TRIP" /* ROUND_TRIP */;
    case "multi":
      return "MULTI_DESTINATION" /* MULTI_DESTINATION */;
    default:
      return "ONE_WAY" /* ONE_WAY */;
  }
};
var mapJourneyCriteria = function (legs, locale, siteId) {
  var cleanedLegs = legs.filter(function (leg) {
    return leg !== null;
  });
  var parsedLegs = cleanedLegs.map(function (leg) {
    var _criteria_, _criteria_1;
    var criteria = decodeURIComponent(leg).replace("from:", "").replace(",to:", "|").replace(",departure:", "|").split("|");
    var completeDateString = criteria[2] || "";
    return {
      departureDate: formatDateString(completeDateString, locale, siteId),
      destination: ((_criteria_ = criteria[1]) === null || _criteria_ === void 0 ? void 0 : _criteria_.split(",toCode")[0]) || "",
      origin: ((_criteria_1 = criteria[0]) === null || _criteria_1 === void 0 ? void 0 : _criteria_1.split(",frCode")[0]) || ""
    };
  });
  return parsedLegs;
};
var parseAdultsFromUrlString = function (adults) {
  var adultsParameterArray = adults.split(":");
  var adultCount = adultsParameterArray[1] ? parseInt(adultsParameterArray[1], 10) : 1;
  return {
    travelerType: "ADULT" /* ADULT */,
    count: adultCount
  };
};
var parseChildrenFromUrlString = function (stringifiedChildren, infantsInLap) {
  var children = [];
  var childrenDataInUrl = stringifiedChildren.split(":");
  if ((childrenDataInUrl === null || childrenDataInUrl === void 0 ? void 0 : childrenDataInUrl[1]) === "0") {
    return [];
  }
  var childrenCountAndAges = childrenDataInUrl[1] ? childrenDataInUrl[1].split("[") : "";
  var childrenCount = parseInt(childrenCountAndAges[0], 10);
  var childrenAndInfantsAges = childrenCountAndAges[1].replace("]", "").split(";").map(function (age) {
    return parseInt(age, 10);
  }) || [];
  var infants = childrenAndInfantsAges.filter(function (age) {
    return age <= 1;
  });
  if (infants.length > 0) {
    childrenCount -= infants.length;
    children.push({
      count: infants.length,
      travelerType: (infantsInLap === null || infantsInLap === void 0 ? void 0 : infantsInLap.includes("Y")) ? "INFANT_IN_LAP" /* INFANT_IN_LAP */ : "INFANT_IN_SEAT" /* INFANT_IN_SEAT */,
      ages: infants
    });
  }
  if (childrenCount > 0) {
    children.push({
      count: childrenCount,
      travelerType: "CHILD" /* CHILD */,
      ages: childrenAndInfantsAges.filter(function (ages) {
        return ages > 1;
      })
    });
  }
  return children;
};
var mapTravelers = function (stringifiedPassengers) {
  var passengersInUrl = stringifiedPassengers.split(",");
  var travelers = [];
  var adultParameterFromUrl = passengersInUrl.find(function (traveler) {
    return traveler.includes("adults");
  }) || "";
  var childrenParameterFromUrl = passengersInUrl.find(function (traveler) {
    return traveler.includes("children");
  }) || "";
  var infantsInLap = passengersInUrl.find(function (traveler) {
    return traveler.includes("infantinlap");
  }) || "N";
  if (adultParameterFromUrl) {
    travelers.push(parseAdultsFromUrlString(adultParameterFromUrl));
  }
  if (childrenParameterFromUrl) {
    var _travelers;
    (_travelers = travelers).push.apply(_travelers, _to_consumable_array(parseChildrenFromUrlString(childrenParameterFromUrl, infantsInLap)));
  }
  return travelers;
};
var mapCabinClass = function (options) {
  if (options.includes("business")) {
    return "BUSINESS" /* BUSINESS */;
  }
  if (options.includes("premium") || options.includes("premium coach") || options.includes("premium_economy")) {
    return "PREMIUM_ECONOMY" /* PREMIUM_ECONOMY */;
  }
  if (options.includes("first")) {
    return "FIRST" /* FIRST */;
  }
  return "COACH" /* COACH */;
};
var getFlightsSearchCriteria = function (url, locale, siteId) {
  var tripType = url.get("trip");
  var obid = url.get("originalBookingId");
  var jcid = url.get("journeysContinuationId");
  var hasCreditIntent = url.get("airCreditIntent");
  var travelers = url.get("passengers") || "";
  var options = url.get("options") || "";
  var legs = [url.get("leg1") || "", url.get("leg2") || "", url.get("leg3") || "", url.get("leg4") || "", url.get("leg5") || ""].filter(function (leg) {
    return leg !== "";
  });
  return {
    journeyCriteria: mapJourneyCriteria(legs, locale, siteId),
    searchPreferences: {
      cabinClass: mapCabinClass(options)
    },
    flightsSearchContext: {
      tripType: mapTripType(tripType),
      originalBookingId: obid,
      journeysContinuationId: jcid,
      hasCreditRedemptionIntent: hasCreditIntent === "true" ? true : null
    },
    travelerDetails: mapTravelers(travelers),
    sortOption: null,
    searchFilterValuesList: []
  };
};
// src/components/flights/flight-criteria-provider.tsx
var __FlightSearchCriteria = gql2(_templateObject1());
var FlightSearchCriteriaContext = createContext(null);
var useFlightsSearchCriteriaContext = function () {
  return useContext(FlightSearchCriteriaContext);
};
var FlightsSearchCriteriaProvider = function (param) {
  var children = param.children;
  var location = useLocation5();
  var context = useBexApi().context;
  var FlightsCriteriaContextValue = useMemo(function () {
    var urlSearchParams = new URLSearchParams(location.search);
    return getFlightsSearchCriteria(urlSearchParams, context.locale, context.siteId);
  }, [context.locale, context.siteId, location.search]);
  return /* @__PURE__ */React15.createElement(FlightSearchCriteriaContext.Provider, {
    value: FlightsCriteriaContextValue
  }, children);
};
FlightsSearchCriteriaProvider.displayName = "sharedui-FlightsSearchCriteriaProvider";
export { ClearableCruiseFilterParams, ClearableGTFilterParams, FlightsSearchCriteriaProvider, GroundTransportationCriteriaProvider, ProductShoppingCriteriaInputActionType, ProductShoppingCriteriaProvider, getCruiseSearchCriteriaFromQueryParams, useFlightsSearchCriteriaContext, useGroundTransportationCriteria, useProductShoppingCriteria, useProductShoppingCriteriaDispatch };